export default __webpack_public_path__ + "img/alarmRules.39221fad.png";